import React, { useRef, useState, useCallback, useEffect } from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import VehicleResults from "../components/VehicleResults";
import FeaturesStrip from "../components/FeaturesStrip";
import DestinationTransfers from "../components/DestinationTransfers";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import { getConfig, getQuote } from "../api";
import { DESTINATIONS as MOCK_DEST, HOTELS as MOCK_HOTELS } from "../mock";

const Home = () => {
  const [result, setResult] = useState(null);
  const [destinations, setDestinations] = useState(MOCK_DEST);
  const [hotels, setHotels] = useState(MOCK_HOTELS);
  const resultsRef = useRef(null);

  useEffect(() => {
    getConfig()
      .then((cfg) => {
        if (cfg?.destinations?.length) setDestinations(cfg.destinations);
        if (cfg?.hotels) setHotels(cfg.hotels);
      })
      .catch(() => {});
  }, []);

  const scrollToResults = useCallback(() => {
    setTimeout(() => {
      resultsRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 120);
  }, []);

  const handleSearch = (payload) => {
    setResult(payload);
    scrollToResults();
  };

  const handleBookClick = () => {
    document
      .getElementById("buscador")
      ?.scrollIntoView({ behavior: "smooth", block: "center" });
  };

  const handleDestinationSelect = async (destinationId) => {
    try {
      const quote = await getQuote({ trip_type: "round", destination_id: destinationId });
      setResult({
        tripType: "round",
        origin: "cun",
        destinationId,
        hotel: "",
        arrivalDate: null,
        departureDate: null,
        passengers: 2,
        quote,
      });
      scrollToResults();
    } catch (e) {
      handleBookClick();
    }
  };

  return (
    <div className="bg-white">
      <Header onBookClick={handleBookClick} />
      <Hero onSearch={handleSearch} destinations={destinations} hotels={hotels} />
      <VehicleResults ref={resultsRef} result={result} />
      <FeaturesStrip />
      <DestinationTransfers onSelect={handleDestinationSelect} />
      <Contact />
      <Footer />
    </div>
  );
};

export default Home;
